<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-package-variant"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="12">
          <v-row>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg">
              <v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2">Thông tin</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addPost('post_info')"
                    >
                      Thêm
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div
                    v-for="(
                      item, index
                    ) in config_footer.post_info"
                    :key="index"
                  >
                    <v-row class="mb-3">
                      <v-col cols="10" class="ma-0 pa-0 pr-1">
                        <v-autocomplete
                          v-model="item.post_id"
                          background-color="#EDF2F7"
                          filled
                          item-value="id"
                          item-text="name"
                          :items="news"
                          label="Bài viết"
                          placeholder="Chọn bài viết"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="2" class="ma-0 pa-0">
                        <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearPost('post_info', index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-col>
            </v-col>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg">
              <v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2">Chính sách</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addPost('post_policy')"
                    >
                      Thêm
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div
                    v-for="(
                      item, index
                    ) in config_footer.post_policy"
                    :key="index"
                  >
                    <v-row class="mb-3">
                      <v-col cols="10" class="ma-0 pa-0 pr-1">
                        <v-autocomplete
                          v-model="item.post_id"
                          background-color="#EDF2F7"
                          filled
                          item-value="id"
                          item-text="name"
                          :items="news"
                          label="Bài viết"
                          placeholder="Chọn bài viết"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="2" class="ma-0 pa-0">
                        <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearPost('post_policy', index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-2">
          <v-row>
            <v-col cols="5.5"  class="content_category mr-2 rounded-lg mb-2">
              <v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2">Bán lẻ</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addContact('contact_sell')"
                    >
                      Thêm
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div
                    v-for="(
                      item, index
                    ) in config_footer.contact_sell"
                    :key="index"
                  >
                    <v-row class="mb-3">
                      <v-col cols="10" class="ma-0 pa-0 pr-1">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            label="Số điện thoại"
                            v-model="item.phone"
                            placeholder="Số điện thoại"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" class="ma-0 pa-0">
                        <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearContact('contact_sell', index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-col>
            </v-col>
            <v-col cols="5.5"  class="content_category mr-2 rounded-lg mb-2">
              <v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2">Bán sỉ</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addContact('contact_wholesale')"
                    >
                      Thêm
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div
                    v-for="(
                      item, index
                    ) in config_footer.contact_wholesale"
                    :key="index"
                  >
                    <v-row class="mb-3">
                      <v-col cols="10" class="ma-0 pa-0 pr-1">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            label="Số điện thoại"
                            v-model="item.phone"
                            placeholder="Số điện thoại"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" class="ma-0 pa-0">
                        <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearContact('contact_wholesale', index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-2">
          <v-row>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg mb-2">
              <v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2">Bán dự án</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addContact('contact_project_sale')"
                    >
                      Thêm
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div
                    v-for="(
                      item, index
                    ) in config_footer.contact_project_sale"
                    :key="index"
                  >
                    <v-row class="mb-3">
                      <v-col cols="10" class="ma-0 pa-0 pr-1">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            label="Số điện thoại"
                            v-model="item.phone"
                            placeholder="Số điện thoại"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" class="ma-0 pa-0">
                        <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearContact('contact_project_sale', index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-col>
            </v-col>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg mb-2">
              <v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2">Bảo hành</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addContact('contact_warranty')"
                    >
                      Thêm
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div
                    v-for="(
                      item, index
                    ) in config_footer.contact_warranty"
                    :key="index"
                  >
                    <v-row class="mb-3">
                      <v-col cols="10" class="ma-0 pa-0 pr-1">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            label="Số điện thoại"
                            v-model="item.phone"
                            placeholder="Số điện thoại"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" class="ma-0 pa-0">
                        <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearContact('contact_warranty', index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-2">
          <v-row>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg mb-2">
              <v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2">Khiếu nại</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addContact('contact_complain')"
                    >
                      Thêm
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div
                    v-for="(
                      item, index
                    ) in config_footer.contact_complain"
                    :key="index"
                  >
                    <v-row class="mb-3">
                      <v-col cols="10" class="ma-0 pa-0 pr-1">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            label="Số điện thoại"
                            v-model="item.phone"
                            placeholder="Số điện thoại"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" class="ma-0 pa-0">
                        <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearContact('contact_complain', index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-col>
            </v-col>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg mb-2">
              <v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2 mb-5">Thời gian làm việc</h3>
                  </v-row>
                </v-col>
                <v-col cols="12">
                    <v-row class="mb-3">
                      <v-col cols="12" class="ma-0 pa-0 pr-1">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            label="Thời gian làm việc"
                            v-model="config_footer.time_work"
                            placeholder="Thời gian làm việc"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                </v-col>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-2">
          <v-row>
            <v-col cols="12" class="content_category mr-2 rounded-lg mb-2">
              <v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2">Trụ sở, văn phòng</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addAddress()"
                    >
                      Thêm
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div
                    v-for="(
                      item, index
                    ) in config_footer.address"
                    :key="index"
                  >
                    <v-row class="mb-3">
                      <v-col cols="2" class="ma-0 pa-0 pr-1">
                        <v-select
                            hide-details
                            filled
                            class="width-input"
                            v-model="item.area_id"
                            :items="areas"
                            item-text="name"
                            item-value="id"
                            clearable
                            label="Khu vực"
                        ></v-select>
                      </v-col>
                      <v-col cols="2" class="ma-0 pa-0 pr-1">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            label="Trụ sở, văn phòng"
                            v-model="item.name"
                            placeholder="Trụ sở, văn phòng"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4" class="ma-0 pa-0 pr-1">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            label="Địa chỉ"
                            v-model="item.address"
                            placeholder="Địa chỉ"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" class="ma-0 pa-0 pr-1">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            label="Thuộc TP: VD Hà Nội"
                            v-model="item.province"
                            placeholder="Thuộc TP: VD Hà Nội"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="1" class="ma-0 pa-0">
                        <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearAddress(index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-col cols="12" class="text-center mt-3">
        <v-btn color="primary" width="180" @click="save()"> Lưu </v-btn>
      </v-col>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GET_LIST_NEWS } from "@/store/modules/news";
import {
  GET_CONFIG_FOOTER,
  UPDATE_CONFIG_FOOTER,
} from "@/store/modules/configs";
import {GET_LIST_AREAS} from '@/store/modules/residence'
export default {
  data() {
    return {
      page: "Quản lý chân trang",

      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý trang",
          disabled: true,
        },
        {
          text: "Chân trang",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      news: "news",
      areas: "areas",
      config_footer: "config_footer",
    }),
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_NEWS}`);
    await this.$store.dispatch(`${GET_CONFIG_FOOTER}`);
    await this.$store.dispatch(`${GET_LIST_AREAS}`);
    this.config_footer.contact_wholesale = this.config_footer.contact_wholesale ?? []
    this.config_footer.contact_project_sale = this.config_footer.contact_project_sale ?? []
  },
  mounted() {},
  methods: {
    addPost(key) {
      this.config_footer[key].push({
        post_id: null
      });
      this.$forceUpdate();
    },
    clearPost(key, i) {
      this.config_footer[key].splice(i, 1);
      this.$forceUpdate();
    },
    addContact(key) {
      this.config_footer[key].push({
        phone: "",
      });
      this.$forceUpdate();
    },
    clearContact(key, i) {
      this.config_footer[key].splice(i, 1);
      this.$forceUpdate();
    },
    addAddress() {
      this.config_footer.address.push({
        area_id: "",
        name: "",
        address: "",
        province: "",
      });
      this.$forceUpdate();
    },
    clearAddress(i) {
      this.config_footer.address.splice(i, 1);
      this.$forceUpdate();
    },
    save() {
      this.$store.dispatch(`${UPDATE_CONFIG_FOOTER}`, this.config_footer).then((data) => {
        console.log(data);
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$store.dispatch(`${GET_CONFIG_FOOTER}`);
        } else {
          alert(data.data.errors);
        }
      });
    }
  },
};
</script>
<style lang="scss">
.content_property {
  padding: 15px;
  border-style: groove;
}
.content_banner {
  padding: 15px;
  border-style: groove;
}
.content_category1 {
  background: #ffffff !important;
}
.content_category {
  background: #ffffff !important;
  .v-input__control {
    height: 65px !important;
  }
  .content-textarea .v-input__control {
    height: 165px !important;
  }
  .v-input--checkbox .v-input__control {
    height: 20px !important;
  }
}
.production .ck-editor__main .ck-content {
  height: 140px;
}
.right {
  float: right;
}
</style>